import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import RecommendationList from './RecommendationList/RecommendationList';
import RecommendationMenu from './RecommendationMenu/RecommendationMenu';
import { ReportRecommendationCont, RecommendationCont } from './ReportRecommendation.styles';
import ReportResultsLegend from '../../../components/ReportResultsLegend/ReportResultsLegend';
import { useReportContext } from '../../../hooks/useReport';

const ReportRecommendation: FC = () => {
  const { t } = useTranslation();

  const { data } = useReportContext();

  const { recommendations } = data ?? {};

  return (
    <ReportRecommendationCont id="ReportRecommendationCont">
      <ReportResultsLegend
        description={t('report.recommendation.description')}
        variant="recommendation"
      />
      {recommendations ? (
        <RecommendationCont id="RecommendationCont">
          {/*<RecommendationMenu {...{ recommendations }} />*/}
          <RecommendationList {...{ recommendations }} />
        </RecommendationCont>
      ) : null}
    </ReportRecommendationCont>
  );
};

export default ReportRecommendation;
